import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../layout/Others/Response_Processing";
// import NavigationData from "../../../layout/Sidebar/NavigationData";
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import { toast } from "react-toastify";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
// import MessageBox from "../../../components/CommonComponents/MessageBox";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
// import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
// import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import useCompressImageConfig from "../../../components/CommonApis/Compressimageapi";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function AddManageArtistCategories({ forceCreate = false, onSuccess, isModal = false }) {
    const headers = getItemToken('access_token')
    const { id } = useParams()
    const combinedRef = useRef([]);
    const navigate = useNavigate();
    const { compressResolutionFormat } = useCompressImageConfig();

    const baseURL = process.env.REACT_APP_Baseurl
    const createApi = `${baseURL}/admin/artist-category/create`
    const editApi = `${baseURL}/admin/artist-category/edit/${id}`

    const { fetchRequest, globalImageUplaodAPI } = useMyContext();
    const [formData, setFormData] = useState({
        name: '',
        slug: '',
        status: 1
    })

    const [formDataError, setFormDataError] = useState({})
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)

    // const { label_management } = NavigationData();
    // const [labelDisplay, setLabelDisplay] = useState([]);

    const setRef = (element, index) => {
        if (element) {
            combinedRef.current[index] = element;
        }
    };

    const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;
                const expectedRatioPrecision = 0.01;
                const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
                // const dimensionMatch = (width === expectedWidth && height === expectedHeight);
                // if (ratioMatch || dimensionMatch) {
                resolve(true); // disable strict ratio check for now if needed, or keep it
                // } else {
                //   resolve(false);
                // }
            };
            img.onerror = () => {
                toast.error('Error loading image');
            };
        });
    };

    const handleFileChange = async (event) => {
        const { files, name } = event.target
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
        // const checkSize = compressResolutionFormat?.videos === 1

        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (files?.length > 0) {
            const newFile = files[0];
            const reader = new FileReader();
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            await readFile(newFile);

            if (!allowedTypes.includes(files[0]?.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, and PNG files are allowed.",
                }));
                setCoverImageFile(null);
                combinedRef.current['image'].focus()
                return;
            }

            if (name == 'image') {
                setCoverImageFile(newFile);
                // if (checkSize) {
                //   const isValidSize = await validateImageRatio(newFile, 1 / 1, 1080, 1080);
                //   if (!isValidSize) {
                //     setFormDataError((prev) => ({
                //       ...prev,
                //       [name]: "Image must be in 1:1 Ratio or 1080x1080px.",
                //     }));
                //   }
                // }
            }
        }
    };

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "slug", "status"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/artist-category/store`, formDataAdd, { headers: headers });
            const result = response?.data;
            if (result?.status) {
                if (coverImageFile) {
                    await handleImageUpload(result?.id)
                }
                setShowOverlay(false);
                toast.success(result?.message)
                if (typeof onSuccess === 'function') {
                    onSuccess(result?.id, formData?.name);
                } else {
                    navigate("/artist-type");
                }
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }


    const handleImageUpload = async (id) => {
        try {
            const formDataAdd = new FormData();
            const modelName = "ArtistCategory";
            formDataAdd.append('image', coverImageFile)
            formDataAdd.append('category_id', id)
            formDataAdd.append('id', id)
            formDataAdd.append('modelName', modelName)
            formDataAdd.append('imageFields[]', 'image')
            const response = await fetchRequest({ method: 'POST', url: globalImageUplaodAPI(), params: {}, data: formDataAdd, });
            if (response?.status) {
                setCoverImageFile(null)
            } else {
                toast.error(response?.message || "Image upload failed")
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err?.message)
        }
    }


    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
        }
        else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
    };

    const handleInputKeyDowntitle = (event) => {
        if (event.key === "Enter" || event.key === "Tab") {
            if (formData?.slug) {
                return
            }
            generateSlug(formData?.name);
        }
    };
    const handleBlurtitle = () => {
        if (formData?.slug) {
            return
        }
        generateSlug(formData?.name);
    };

    const generateSlug = async (name) => {
        const slug = await slugGenerator(name)
        setFormData((prev) => ({
            ...prev,
            'slug': slug,
        }));
    };

    const fetchData = async () => {
        try {
            setShowOverlay(true)
            const response = await fetchRequest({ method: 'GET', url: id ? editApi : createApi })

            if (response?.status) {
                setFormData(response?.data)
                toast.success(response?.message)
            }
        } catch (error) {
            toast.error(error.response.message)
        } finally {
            setShowOverlay(false)
        }
    }



    const handleBlurTitleEdit = () => {
        generateSlug(formData?.slug);
    };


    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.name || formData?.name.trim().length < 3 || formData?.name.trim().length > 100) {
            toast.error("Name must be between 3 and 100 characters.");
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: "Name must be between 3 and 100 characters.",
            }));
            combinedRef.current['name'].focus()
            formIsValid = false;
        }

        if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
            toast.error("Slug must be between 3 and 100 characters.");
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: "Slug must be between 3 and 100 characters.",
            }));
            combinedRef.current['slug'].focus()
            formIsValid = false;
        }
        return formIsValid;
    }

    const handleStore = () => {
        const creating = forceCreate || !id;
        if (creating) {
            if (formValidation()) {
                handleAdd()
            } else {
                console.log("validation")
            }
        } else {
            handleUpdate()
        }
    }

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "slug", "status"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }

            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/artist-category/update/${id}`, formDataAdd, { headers: headers });
            const result = response?.data;
            if (result?.status) {
                if (coverImageFile) {
                    await handleImageUpload(result?.ArtistCategory?.id)
                }
                setShowOverlay(false);
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }

    const handleClearSelectFile = (value) => {
        setCoverImageFile(null)
    }

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <div className="pb-5">
            {showOverlay && (<Response_Processing></Response_Processing>)}
            {!isModal && <AdminBackNavigation path={`${"/artist-type"}`} text="Back" />}
            {!isModal && <AdminSaveHeader buttonId="artist-category-submit-up" heading={!id ? "Add Artist Type" : "Edit Artist Type"} saveText={!id ? "Save" : "Update"} saveMethod={handleStore} />}
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={!id ? "Artist Type Details" : formData?.name} />
                        <MessageLabel text="Name" className="mandatorySimple" />
                        <AdminCustomInput id="artist-category-name" type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Name"} ref={(el) => (combinedRef.current.name = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.name} />
                        <MessageLabel text="Slug" className="mandatorySimple" />
                        <AdminCustomInput id="artist-category-slug" type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} onBlur={() => handleBlurTitleEdit()} placeHolder={"Slug"} error={formDataError?.slug} />

                    </Wrapper>
                </LeftWrapper>

                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text="Image" />
                        {/* <MessageLabel text="Image" className="" /> */}
                        <p className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Select the image</p>
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={coverImageFile}
                            uploadedImage={formData?.image}
                            onDelete={handleClearSelectFile}
                            fileInputRef={setRef}
                            name="image"
                            id={id}
                            idAttribute="artist-category-image"
                            ref={(el) => (combinedRef.current.image = el)}
                            error={formDataError?.image}
                        />
                    </Wrapper>

                    {/* <Wrapper>
            <MessageHeading text="Visibility" />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text="Status" className="" />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id="artist-category-status" name={"status"} checked={formData?.status == 1} onChange={handleInput} />
              </div>
            </div>
          </Wrapper> */}

                </RightWrapper>
                <AdminCustomButton id="artist-category-submit-down" className='px-3 py-1 m-0 ms-auto' saveMethod={handleStore} saveText={!id ? "Save" : "Update"} />
            </FormContainer>
        </div>
    );
}

export default AddManageArtistCategories;
